import { render } from "./LiveDetail.vue?vue&type=template&id=b6267696&scoped=true"
import script from "./LiveDetail.vue?vue&type=script&lang=js"
export * from "./LiveDetail.vue?vue&type=script&lang=js"

import "./LiveDetail.vue?vue&type=style&index=0&id=b6267696&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-b6267696"

export default script